import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSendMessageStatus = createSelector(
  [(store: RootState) => store.paymentNoticeDetail.sendMessageStatus],
  (sendMessageStatus) => sendMessageStatus
);
